import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=2ef0eb20&scoped=true"
import script from "./registered.vue?vue&type=script&lang=js"
export * from "./registered.vue?vue&type=script&lang=js"
import style0 from "./registered.vue?vue&type=style&index=0&id=2ef0eb20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0eb20",
  null
  
)

export default component.exports